import React, { useEffect, useState } from "react";

//redux
import { connect, useDispatch, useSelector } from "react-redux";

//MUI
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import { Cancel } from "@material-ui/icons";

//types
import { CLOSE_DIAMOND_SHOP_DIALOG } from "../../store/diamondShop/types";

//action
import {
  createShopDiamond,
  editShopDiamond,
} from "../../store/diamondShop/action";
import { permissionError } from "../../util/Alert";

const DiamondShopDialog = (props) => {
  const dispatch = useDispatch();

  const { dialog: open, dialogData } = useSelector(
    (state) => state.diamondShop,
  );
  const hasPermission = useSelector((state) => state.admin.admin.flag);

  const [mongoId, setMongoId] = useState("");
  const [price, setPrice] = useState();
  const [diamond, setDiamond] = useState();
  const [imageData, setImageData] = useState(null);
  const [imagePath, setImagePath] = useState(null);

  const [errors, setError] = useState({
    diamond: "",
    price: "",
    image: "",
  });

  useEffect(() => {
    if (dialogData) {
      setMongoId(dialogData._id);
      setDiamond(dialogData.diamond);
      setImagePath(dialogData.image);
      setPrice(dialogData.price);
    }
  }, [dialogData]);

  useEffect(
    () => () => {
      setError({
        diamond: "",
        price: "",
        image: "",
      });
      setMongoId("");
      setPrice(null);
      setDiamond(null);
      setImageData(null);
      setImagePath(null);
    },
    [open],
  );

  useEffect(() => {
    window.onbeforeunload = closePopup();
  }, []);

  const HandleInputImage = (e) => {
    if (e.target.files[0]) {
      setImageData(e.target.files[0]);
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        setImagePath(reader.result);
      });
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const closePopup = () => {
    dispatch({ type: CLOSE_DIAMOND_SHOP_DIALOG });
  };

  const handleSubmit = (e) => {
    console.log("for seller: ", props.forSeller);
    e.preventDefault();
    if (!price || !diamond || !mongoId ? !imageData : !imagePath) {
      const errors = {};
      if (!price) errors.price = "Price is Required!";
      if (!diamond) errors.diamond = "Diamond is Required!";
      if (!mongoId) {
        if (!imageData || !imagePath) {
          errors.image = "Diamond Photo is Required!";
        } else {
          errors.image = "";
        }
      }
      return setError({ ...errors });
    }

    if (!hasPermission) return permissionError();
    const formData = new FormData();

    formData.append("image", imageData);
    formData.append("price", price);
    formData.append("diamond", diamond);
    formData.append("forSeller", props.forSeller ? true : false);
    if (mongoId) {
      formData.append("id", mongoId);
      props.editShopDiamond(mongoId, formData);
    } else {
      props.createShopDiamond(formData);
    }
  };

  return (
    <>
      <Dialog
        open={open}
        aria-labelledby="responsive-dialog-title"
        onClose={closePopup}
        disableBackdropClick
        disableEscapeKeyDown
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle id="responsive-dialog-title">
          <span className="text-danger font-weight-bold h4">
            {" "}
            Diamond Shop{" "}
          </span>
        </DialogTitle>

        <IconButton
          style={{
            position: "absolute",
            right: 0,
          }}
        >
          <Tooltip title="Close">
            <Cancel className="text-danger" onClick={closePopup} />
          </Tooltip>
        </IconButton>
        <DialogContent>
          <div className="modal-body pt-1 px-1 pb-3">
            <div className="d-flex flex-column">
              <form>
                <div className="form-group">
                  <label className="mb-2 text-gray">Diamond</label>
                  <input
                    type="text"
                    className="form-control"
                    required=""
                    value={diamond}
                    onChange={(e) => {
                      setDiamond(e.target.value);

                      if (!e.target.value) {
                        return setError({
                          ...errors,
                          diamond: "Diamond is Required!",
                        });
                      } else {
                        return setError({
                          ...errors,
                          diamond: "",
                        });
                      }
                    }}
                  />
                  {errors.diamond && (
                    <div className="ml-2 mt-1">
                      {errors.diamond && (
                        <div className="pl-1 text__left">
                          <span className="text-red">{errors.diamond}</span>
                        </div>
                      )}
                    </div>
                  )}
                </div>
                <div className="form-group mt-4">
                  <label className="mb-2 text-gray">Price (PHP)</label>
                  <input
                    type="text"
                    className="form-control"
                    required=""
                    value={price}
                    onChange={(e) => {
                      setPrice(e.target.value);

                      if (!e.target.value) {
                        return setError({
                          ...errors,
                          price: "Price is Required!",
                        });
                      } else {
                        return setError({
                          ...errors,
                          price: "",
                        });
                      }
                    }}
                  />
                  {errors.price && (
                    <div className="ml-2 mt-1">
                      {errors.price && (
                        <div className="pl-1 text__left">
                          <span className="text-red">{errors.price}</span>
                        </div>
                      )}
                    </div>
                  )}
                </div>
                <div className="form-group mt-4">
                  <label className="mb-2 text-gray">Diamond Image</label>
                  <input
                    type="file"
                    className="form-control form-control-sm"
                    accept="image/*"
                    required=""
                    onChange={HandleInputImage}
                  />
                  {errors.image && (
                    <div className="ml-2 mt-1">
                      {errors.image && (
                        <div className="pl-1 text__left">
                          <span className="text-red">{errors.image}</span>
                        </div>
                      )}
                    </div>
                  )}
                  {imagePath && (
                    <>
                      <img
                        height="70px"
                        width="70px"
                        alt="app"
                        src={imagePath}
                        style={{
                          boxShadow: "0 5px 15px 0 rgb(105 103 103 / 0%)",
                          // border: "2px solid #fff",
                          borderRadius: 10,
                          marginTop: 10,
                          float: "left",
                          objectFit: "cover",
                        }}
                      />
                    </>
                  )}
                </div>
                <div className={imagePath ? "mt-5 pt-5" : "mt-5"}>
                  <button
                    type="button"
                    className="btn btn-outline-info ml-2 btn-round float__right icon_margin"
                    onClick={closePopup}
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-round float__right btn-danger"
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default connect(null, { createShopDiamond, editShopDiamond })(
  DiamondShopDialog,
);
